exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tipsBox[data-v-5ace15de] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 13px;\n  color: #9f9f9f;\n}\n.tipsBox span[data-v-5ace15de] {\n  margin-left: 5px;\n}\n", ""]);

// exports
